import { Component, OnInit, Optional } from '@angular/core';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { firstValueFrom, Subscription } from 'rxjs';
import { ActionColor, CheckBoxAction } from 'src/app/interfaces/custom-table/custom-table-action.interface';
import { QuotationDetailModel } from 'src/app/models/preliminaries/quotation-detail.model';
import { ColumnResponseModel } from 'src/app/models/responses/column-response.model';
import { PagedResponseModel } from 'src/app/models/responses/paged-response.model';
import { MasterSolutionDetailSelectTableModel } from 'src/app/models/tables/preliminaries/master-solution-detail-select-table.model';
import { MasterSolutionSelectTableModel } from 'src/app/models/tables/preliminaries/master-solution-select-table.model';
import { BreakdownService } from 'src/app/services/preliminaries/breakdown.service';
import { MasterSolutionDetailService } from 'src/app/services/preliminaries/master-solution-detail.service';
import { MasterSolutionService } from 'src/app/services/preliminaries/master-solution.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-detail-from-solution',
  templateUrl: './detail-from-solution.component.html',
  styleUrls: ['./detail-from-solution.component.scss'],
  standalone: false
})
export class DetailFromSolutionComponent implements OnInit {
  ascendant: boolean = true;
  ascendantDetail: boolean = true;
  checkboxActions: CheckBoxAction[] = [
    {
      label: 'Agregar',
      icon: '',
      color: ActionColor.SUCCESS,
      action: 'add'
    },
  ];

  columnSort: string | null = null;
  columnSortDetail: string | null = null;
  currentStep: number = 1;
  dataMasterSolution: PagedResponseModel<MasterSolutionSelectTableModel> = new PagedResponseModel<MasterSolutionSelectTableModel>();
  dataMasterSolutionDetail: PagedResponseModel<MasterSolutionDetailSelectTableModel> = new PagedResponseModel<MasterSolutionDetailSelectTableModel>();
  filters: ColumnResponseModel[] = [];
  limit: number = 10;
  limitDetail: number = 10;
  quotationSolutionModel: QuotationDetailModel = new QuotationDetailModel();
  page: number = 1;
  pageDetail: number = 1;
  masterSolutionDetailHeader: ColumnResponseModel[] = [];
  masterSolutionHeader: ColumnResponseModel[] = [];
  masterSolutionId: number | null = null;
  suscription: Subscription;
  quotationVersionId: number = 0;

  constructor(
    private breakdownService: BreakdownService,
    public config: DynamicDialogConfig,
    private masterSolutionDetailService: MasterSolutionDetailService,
    private masterSolutionService: MasterSolutionService,
    private toastHandlerService: ToastHandlerService,
    @Optional() private ref: DynamicDialogRef) { }

  async ngOnInit() {
    const input$ = this.config.data?.inputs$;
    if (!input$) {
      console.error('inputs$ no está definido en config.data');
      return;
    }

    this.suscription = input$?.subscribe((inputs: any) => {
      this.quotationSolutionModel = inputs.quotationSolutionModel;
      this.quotationVersionId = inputs.quotationVersionId;
    });
    await this.loadDataForStep(1);
  }

  async createBreakdownFromMasterSolutionAsync(listArticleIds: number[]) {
    try {
      const response = await firstValueFrom(this.breakdownService.createBreakdownFromMasterSolutionAsync(this.quotationVersionId, this.quotationSolutionModel.quotationDetailId, this.masterSolutionId!, listArticleIds));
      if (response) {
        const output$ = this.config.data?.output$;
        output$?.next({ type: 'quotationDetailId', payload: response.quotationDetailId });
        this.toastHandlerService.showToast('success', 'Se proceso la maestra solución exitosamente.', '');
      }
      if (this.ref) this.ref.close();
    } catch (error) {
      console.error('Error al procesar la maestra solución:', error);
    }
  }

  async loadDataForStep(step: number) {
    try {
      switch (step) {
        case 1:
          await Promise.all([
            this.getColumnsFoMasterSolution(),
            this.getMasterSolutionsForSelection()
          ]);
          break;
        case 2:
          if (this.masterSolutionId) {
            await Promise.all([
              this.getColumnsForMasterSolutionDetail(),
              this.getMasterSolutionDetailsForSelection()
            ]);
          }
          break;
      }
    } catch (error) {
      console.error(`Error cargando datos.`, error);
    }
  }

  async getColumnsFoMasterSolution() {
    try {
      if (this.masterSolutionHeader.length === 0) {
        this.masterSolutionHeader = await firstValueFrom(this.masterSolutionService.getColumnsMasterSolutionSelection());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta.', error);
    }
  }

  async getColumnsForMasterSolutionDetail() {
    try {
      if (this.masterSolutionDetailHeader.length === 0) {
        this.masterSolutionDetailHeader = await firstValueFrom(this.masterSolutionDetailService.getColumnsMasterSolutionDetails());
      }
    } catch (error) {
      console.error('Error al buscar las columnas para la consulta detalle.', error);
    }
  }

  async getMasterSolutionById(masterSolutionId: number) {
    try {
      const masterSolution = await firstValueFrom(this.masterSolutionService.getByIdAsync(masterSolutionId));
      this.masterSolutionId = masterSolution.masterSolutionId;
    } catch (error) {
      console.error('Error al obtener la maestra de soluciones.', error);
    }
  }

  async getMasterSolutionsForSelection() {
    try {
      this.dataMasterSolution = await firstValueFrom(this.masterSolutionService.getMasterSolutionsForSelection(this.page, this.limit, this.columnSort, this.ascendant, this.filters));
    } catch (error) {
      console.error('Error al obtener la lista de maestra de soluciones.', error);
    }
  }

  async getMasterSolutionDetailsForSelection() {
    try {
      this.dataMasterSolutionDetail = await firstValueFrom(this.masterSolutionDetailService.getMasterSolutionDetailsForSelection(this.pageDetail, this.limitDetail,
        this.columnSortDetail, this.ascendantDetail, this.filters, this.masterSolutionId ?? 0));
    } catch (error) {
      this.dataMasterSolutionDetail = new PagedResponseModel<MasterSolutionDetailSelectTableModel>();
      console.error('Error al obtener los detalles de maestra solución.', error);
    }
  }

  async goToStep(step: number, activateCallback: any) {
    if (step < this.currentStep) { this.clearFutureStepSelections(step); }
    if (!this.validateCurrentStepSelection(step)) { return; }
    await this.loadDataForStep(step);
    this.currentStep = step;
    activateCallback(step);
  }

  private clearFutureStepSelections(currentStep: number) {
    switch (currentStep) {
      case 1:
        this.masterSolutionId = null;
        break;
    }
  }

  async onAction(event: { action: string, item?: MasterSolutionDetailSelectTableModel, selectedItems?: number[] }) {
    if (event.action == 'add' && event.selectedItems) {
      Swal.fire({
        text: '¿Realmente desea importar los artículos seleccionados?',
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Si',
        cancelButtonText: 'No'
      }).then(async (result) => {
        if (result.isConfirmed) {
          try {
            await this.createBreakdownFromMasterSolutionAsync(event.selectedItems!)
          } catch (error) {
            console.error('Error al crear el pedido.', error);
          }
        } else {
          this.toastHandlerService.showToast('warning', 'Proceso de copiar solucón cancelado.', '');
        }
      });
    } else {
      console.error('No se seleccionaron items.');
    }
  }

  async onFilterChange(event: { filters: any }) {
    const filters = event.filters.map((value: any, index: any): any => ({ value, index }))
      .sort((a: any, b: any) => b.index - a.index).map((item: any) => item.value);
    this.filters = this.removeDuplicates(filters);
    this.filters.forEach((filter: any) => this.processFilter(filter));
  }

  async selectionChange(event: { selectedItem?: any }) {
    const selectedId = event?.selectedItem?.id;
    if (!selectedId) {
      this.clearFutureStepSelections(this.currentStep);
      return;
    }
    switch (this.currentStep) {
      case 1:
        await this.getMasterSolutionById(selectedId);
        break;
    }
  }

  async onPageChange(event: { page: number; pageSize: number, sortField: string | undefined, sortOrder: number }) {
    switch (this.currentStep) {
      case 1:
        this.page = event.page;
        this.limit = event.pageSize;
        this.columnSort = event.sortField || null;
        this.ascendant = event.sortOrder === 1;
        await this.getMasterSolutionsForSelection()
        break;
      case 2:
        this.pageDetail = event.page;
        this.limitDetail = event.pageSize;
        this.columnSortDetail = event.sortField || null;
        this.ascendantDetail = event.sortOrder === 1;
        await this.getMasterSolutionDetailsForSelection()
        break;
    }
  }

  processFilter(filter: any): void {
    const { propertyName, valueFilter, valueAlterFilter } = filter;
    if (valueFilter === null || valueFilter === undefined || valueFilter === '' || valueFilter === 0) {
      this.filters = this.filters.filter(f => f.propertyName !== propertyName);
    } else {
      const existingFilter = this.filters.find(f => f.propertyName === propertyName);
      if (existingFilter) {
        existingFilter.valueFilter = valueFilter;
        existingFilter.valueAlterFilter = valueAlterFilter;
      }
    }
  }

  removeDuplicates(filters: any[]): any[] {
    return filters.filter((value, index, self) =>
      index === self.findIndex((t: any) => t.propertyName === value.propertyName)
    );
  }

  validateCurrentStepSelection(step: number): boolean {
    switch (step) {
      case 2:
        if (!this.masterSolutionId) {
          this.toastHandlerService.showToast('warning', 'Debe seleccionar una maestra se soluciones válida antes de avanzar al detalle.', 'Atención');
          return false;
        }
        break;
    }
    return true;
  }
}

